<template>
    <div>
        <div class="report-builder-filter-settings">
            <div class="card mt-2 mb-3 mx-0">
                <div class="card-body p-0">
                    <div class="accordion accordion-flush">
                        <div class="accordion-item border-0">
                            <div class="accordion-header ms-2 me-5">
                                <button class="text-start collapsed p-2 accordion-button section-accordion-button" type="button"
                                    data-bs-target="#report-filter-settings-collapse"
                                    data-bs-toggle="collapse"
                                    aria-expanded="false"
                                    aria-controls="report-filter-settings-collapse">
                                    <h4 class="mb-0">Report Filter Settings</h4>
                                </button>
                            </div>
                            <div id="report-filter-settings-collapse" class="collapse accordion-collapse section-accordion-collapse">
                                <div class="card-body">
                                    <div class="row">
                        <div class="col-12">
                            <nav>
                                <div class="d-flex">            
                                    <span class="py-1 me-3 mb-0 h4 text-nowrap">Static Page Filters:</span>
                                    <div class="input-group" >
                                        <v-select id="page-filter-dropdown" :options="page_filter_options" placeholder="Select the Filter to add to Report..."
                                            :searchable="true" class="searchable-select column-display w-50"
                                            :selectable="(option) => option.text !== ''"
                                            label="text" @search="searchPageFilterOption"
                                            @update:modelValue="emitPageFilterChange"
                                            :filterable="false">
                                            <template #open-indicator="{ attributes }">
                                                <span v-bind="attributes" style="width: 12px; line-height: 8px;"><svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/></svg></span>
                                            </template>
                                            <template #selected-option="{ text, category }">
                                                <span>{{"Select the Filter to add to the report..."}}</span>
                                            </template>

                                            <template #option="{ text, category }">
                                                <div class="suboption" :data-subcategory="category"
                                                    :class="{ 'show': category === null || category === '' }">
                                                    {{ text }}
                                                </div>
                                            </template>
                                            
                                            <template #no-options="{ search, searching, loading }">
                                                <div class="suboption show">
                                                    <em>No results found</em>
                                                </div>
                                            </template>
                                        </v-select>

                                        <button class="btn btn-secondary" data-bs-toggle="modal" data-bs-target="#page-filter-modal" @click="addPageFilter" >
                                            <i class="fa fa-plus"></i>
                                        </button>                                                     
                                    </div>
               
                                </div>    
                                    
                                <div class="d-flex p-2">
                                    <span class="badge badge-primary me-2" v-for="(filter,index) in page_level_filters_list" :key="index">
                                        &nbsp;{{ filter.admin_name }}
                                        <a v-if="filter.id" 
                                           href="#" 
                                           class="ms-2 text-decoration-none" 
                                           data-bs-toggle="modal" 
                                           data-bs-target="#page-filter-modal" 
                                           @click.prevent="editPageFilter(filter)"
                                           title="Open filter builder">
                                            <i class="fas fa-external-link-alt"></i>
                                        </a>
                                        <i class="fa fa-remove ms-2" id="remove-filter" @click="removePageFilterByIndex(index)"></i>
                                    </span>
                                </div>
                            </nav>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 mt-2">
                            <h4 class="mb-3">User-Defined Filters:</h4>
                            <draggable
                                v-model="dimensional_filters_list"
                                handle=".udf-group-drag-handle"
                                item-key="group_name"
                                tag="div"
                                class="udf-groups-list"
                                @end="onGroupsDragEnd"
                            >
                                <template #item="{ element: group, index: group_index }">
                                    <div class="card mb-3">
                                        <div class="card-body py-2">
                                            <div class="d-flex align-items-center flex-wrap gap-2 mb-2">
                                                <span class="udf-group-drag-handle udf-drag-handle text-muted me-1" style="cursor: move;" title="Drag to reorder"><i class="fas fa-grip-vertical"></i></span>
                                                <label class="form-label mb-0 flex-grow-1">{{ group.group_name }}</label>
                                                <button type="button" class="btn btn-sm btn-secondary" data-bs-toggle="modal" data-bs-target="#filter-group-modal" @click="editFilterGroup(group_index, 'Update')" title="Edit group">
                                                    <img class="icon" src="/img/icons/avid-icons/edit.svg" alt="">
                                                </button>
                                                <button type="button" class="btn btn-sm btn-secondary" @click="editFilterGroup(group_index, 'Delete')" title="Delete group">
                                                    <i class="fas fa-trash"></i>
                                                </button>
                                            </div>
                                            <draggable
                                                v-model="group.filters"
                                                handle=".udf-filter-drag-handle"
                                                :item-key="(f, i) => f.id != null ? String(f.id) : 'new-'+i"
                                                tag="div"
                                                class="udf-filters-list ms-3"
                                                @end="() => onFiltersDragEnd(group_index)"
                                            >
                                                <template #item="{ element: filter, index: filter_index }">
                                                    <div class="d-flex align-items-center gap-2 py-1 border-bottom border-light">
                                                        <span class="udf-filter-drag-handle udf-drag-handle text-muted"  style="cursor: move;" title="Drag to reorder"><i class="fas fa-grip-vertical"></i></span>
                                                        <span class="text-nowrap flex-grow-1">{{ filter.label }}</span>
                                                        <button type="button" class="btn btn-sm btn-secondary" data-bs-toggle="modal" data-bs-target="#dimension-filter-modal" @click="editFilterWithinGroup(filter_index, group_index, 'Update')" title="Edit filter">
                                                            <img class="icon" src="/img/icons/avid-icons/edit.svg" alt="">
                                                        </button>
                                                        <button type="button" class="btn btn-sm btn-secondary" @click="editFilterWithinGroup(filter_index, group_index, 'Delete')" title="Delete filter">
                                                            <i class="fas fa-trash"></i>
                                                        </button>
                                                    </div>
                                                </template>
                                            </draggable>
                                            <button type="button" class="btn btn-sm btn-secondary mt-2 ms-3" data-bs-toggle="modal" data-bs-target="#dimension-filter-modal" @click="editFilterWithinGroup(null, group_index, 'Add')">
                                                <i class="fa fa-plus"></i> Add Filter
                                            </button>
                                        </div>
                                    </div>
                                </template>
                            </draggable>
                            <button type="button" class="btn btn-secondary" data-bs-toggle="modal" data-bs-target="#filter-group-modal" @click="editFilterGroup(null, 'Add')">
                                <i class="fa fa-plus"></i> Add Filter Group
                            </button>
                        </div>
                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>  

        <!-- User-Defined Filter Modal - Grouped -->
        <div class="modal fade" id="dimension-filter-modal" aria-labelledby="dimension-filter-modal" data-bs-backdrop="static" aria-hidden="true">
            <report-builder-udf-popup :action="action_for_filter_in_group" :client_id="report_page.client_id"
                :dimensional_filter="dimensional_filter" :data_blend="data_blend" :metrics_filters="local_metrics_filters" @updateFilterWithinGroup="updateFilterWithinGroup"></report-builder-udf-popup>
        </div>


        <!-- Filter Group Modal -->
        <div class="modal fade" id="filter-group-modal" aria-labelledby="filter-group-modal" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header border-bottom-0 pb-0">
                        <div class="text-center w-100">
                            <button type="button" class="btn btn-white float-end close-modal" data-bs-dismiss="filter-group-modal" @click.prevent="closeModal('filter-group-modal')">
                                <img class="icon" src="/img/icons/avid-icons/close.svg" alt=""> 
                            </button>
                            <h3 class="mt-2">{{ this.action_for_filter_group }} a Filter Group</h3>
                        </div>
                    </div>
                    <div class="modal-body pt-0 ">
                        <div class="row">
                            <div class="col-12">
                                <div class="mb-3">
                                    <label class="form-label">Filter Group Name</label>
                                    <input type="text" id="filter-group-name-input" class="form-control" v-model="dimensional_filter_group.group_name"
                                        :class="{ 'is-invalid': local_filter_group_errors.group_name !== '' }" @change="clearErrorForGroupField('group_name')" aria-label="Filter Group Name">
                                    <div class="text-danger invalid-feedback" v-if="local_filter_group_errors.group_name !== ''">
                                        {{local_filter_group_errors.group_name}}
                                    </div>
                                </div>
                                <div class="mb-3" v-if="sectionOptions.length > 0">
                                    <label class="form-label">Apply to sections (optional)</label>
                                    <p class="small text-muted mb-1">Leave empty to apply this filter group to all sections.</p>
                                    <v-select
                                        v-model="dimensional_filter_group.section_ids"
                                        :options="sectionOptions"
                                        label="text"
                                        :reduce="opt => opt.value"
                                        multiple
                                        placeholder="All sections"
                                        class="searchable-select v-multi-select column-display">
                                    </v-select>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="mt-3">
                                    <button type="submit" class="btn btn-secondary" id="save-button"
                                            @click.prevent="updateFilterGroup"
                                            :disabled="form.busy">
                                        <i class="fa" :class="action_for_filter_group === 'Add' ? 'fa-plus': 'fa-save'"></i> {{ this.action_for_filter_group }} Filter Group
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="page-filter-modal" aria-labelledby="page-filter-modal"  data-bs-backdrop="static" aria-hidden="true">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header border-bottom-0 pb-0">
                        <div class="text-center w-100">
                            <button type="button" class="btn btn-white float-end close-modal"
                                data-bs-dismiss="page-filter-modal" @click="closeModal('page-filter-modal')" data-bs-toggle="tooltip" title="Close">
                                <img class="icon" src="/img/icons/avid-icons/close.svg" alt=""> 
                            </button>
                            <h3 class="mt-2">Filter Builder</h3>
                        </div>
                    </div>
                    <div class="modal-body pt-0 pb-0">
                        <metric-filter-builder 
                            :data_blend="data_blend" 
                            :modal_id="'page-filter-modal'" 
                            :client_id="report_page.client_id"
                            ref="mf_builder" 
                            :type="'filter'" 
                            :clients="clients"
                            @update="pageFilterAdded">
                        </metric-filter-builder>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import Swal from 'sweetalert2';
import draggable from 'vuedraggable';
import { useNotifications } from '../../../composables/useNotifications';
import vSelect from "vue3-select";

export default defineComponent({
    name: 'ReportBuilderFilterSettings',
    components: {
        Swal,
        draggable,
        vSelect
    },
    setup() {
        const { showNotification } = useNotifications();
        return {
            showNotification
        };
    },
    props: {
        report_page: {
            type: Object,
            required: true
        },
        data_blend: {
            type: Object,
            required: true
        },
        metrics_filters: {
            type: Array,
            required: true
        },
        clients: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            columns: [],
            local_metrics_filters: [],
            dimensional_filters_list: [], 
            filter_index_within_group: null,
            group_index: null,
            action_for_filter_in_group: null,
            action_for_filter_group: null,
            
            dimensional_filter: {
                label: '',
                field_type: '',
                is_required: false,
                column: null,
                default_value: [],
                order: null
            },
            dimensional_filter_group: {
                group_name: '',
                filters: [],
                section_ids: null
            },
            local_filter_group_errors: {
                group_name: '',
            },
            form: {
                successful: false,
                busy: false,
                error: false
            },
            page_level_filters_list: [],
            page_filter_options: []
        };
    },
    computed: {
        sectionOptions() {
            if (!this.report_page || !this.report_page.sections || !this.report_page.sections.length) {
                return [];
            }
            return this.report_page.sections.map(s => ({
                value: s.id,
                text: s.title || ('Section ' + s.id)
            }));
        }
    },
    beforeMount() {
        this.dimensional_filters_list = [];
        this.local_metrics_filters = [...this.metrics_filters];
        this.page_filter_options = this.getAllPageFilterOptions();

        if(this.report_page.filters != null) {
            for(let i = 0; i < this.report_page.filters.length; i++) {
                const f = this.local_metrics_filters.find((filter) => filter.id === this.report_page.filters[i].report_metrics_filters_id);
                if(f != null) {
                    this.page_level_filters_list.push(f);
                    const val = this.page_level_filters_list[this.page_level_filters_list.length-1].id;
                    this.page_filter_options = this.page_filter_options.filter(option => option.value !== val);
                }
            }
        }

        if(this.report_page.dimensions != null) {
            const groupsById = {};
            (this.report_page.dimensional_filter_groups || this.report_page.dimensionalFilterGroups || []).forEach(g => {
                groupsById[g.name] = g;
            });
            let group = {
                group_name: '',
                filters: [],
                section_ids: null,
                id: null,
                order: null
            };
            for(let i = 0; i < this.report_page.dimensions.length; i++) {
                const dim = this.report_page.dimensions[i];
                const dimGroupName = dim.filter_group;
                if(group.group_name !== dimGroupName) {
                    if(group.group_name !== '') {
                        const meta = groupsById[group.group_name];
                        if (meta) {
                            group.id = meta.id;
                            group.order = meta.order ?? null;
                            group.section_ids = meta.section_ids && meta.section_ids.length ? meta.section_ids : null;
                        }
                        this.dimensional_filters_list.push(group);
                    }
                    group = {
                        group_name: dimGroupName,
                        filters: [],
                        section_ids: null,
                        id: null,
                        order: null
                    };
                    const meta = groupsById[dimGroupName];
                    if (meta) {
                        group.id = meta.id;
                        group.order = meta.order ?? null;
                        group.section_ids = meta.section_ids && meta.section_ids.length ? meta.section_ids : null;
                    }
                }
                const f = {
                    id: this.report_page.dimensions[i].id,
                    label: this.report_page.dimensions[i].label,
                    field_type: this.report_page.dimensions[i].field_type,
                    is_required: this.report_page.dimensions[i].is_required,
                    column: this.report_page.dimensions[i].column,
                    default_value: this.report_page.dimensions[i].default_value,
                    order: this.report_page.dimensions[i].order
                };
                group.filters.push(f);
            }
            if(group.filters.length > 0) {
                const meta = groupsById[group.group_name];
                if (meta) {
                    group.id = meta.id;
                    group.order = meta.order ?? null;
                    group.section_ids = meta.section_ids && meta.section_ids.length ? meta.section_ids : null;
                }
                this.dimensional_filters_list.push(group);
            }
            if (this.dimensional_filters_list.length > 0) {
                // Sort groups by order (backend order), then assign explicit order by index for future saves
                this.dimensional_filters_list.sort((a, b) => {
                    const orderA = a.order != null ? Number(a.order) : 999;
                    const orderB = b.order != null ? Number(b.order) : 999;
                    return orderA - orderB;
                });
                this.assignGroupOrders();
                this.$emit('updateUserDefinedFilters', this.dimensional_filters_list);
            }
        }
    },
    methods: {
        getAllPageFilterOptions() {
            const filter_list = [];
            this.local_metrics_filters.forEach((mf) => {
                if (this.page_level_filters_list.indexOf(mf) < 0) {
                    if(mf.type === 'filter' && mf.data_blend_type === this.report_page.data_blend_type) {
                        filter_list.push({
                            category: "",
                            text: mf.admin_name,
                            type: mf.format,
                            value: mf.id,
                        });
                    }
                }
            });
            return filter_list;
        },
        searchPageFilterOption(search_key) {
            const option_list = this.getAllPageFilterOptions();
            if(search_key === "") {
                this.page_filter_options = option_list;
            } else {
                this.page_filter_options = option_list.filter(option => option.text.toLowerCase().includes(search_key.toLowerCase()));
            }
        },
        addPageFilter() {
            this.$refs.mf_builder.setMetricFilter(null);
        },
        editPageFilter(filter) {
            // Find the full filter object from local_metrics_filters
            const fullFilter = this.local_metrics_filters.find((mf) => mf.id === filter.id);
            if (fullFilter) {
                this.$refs.mf_builder.setMetricFilter(fullFilter);
            } else {
                // If not found, use the filter object directly
                this.$refs.mf_builder.setMetricFilter(filter);
            }
        },
        pageFilterAdded(mf) {
            let found = false;
            for(let i = 0; i < this.page_filter_options.length; i++) {
                if(this.page_filter_options[i].id === mf.id) {
                    this.page_filter_options[i] = mf;
                    found = true;
                    break;
                }
            }

            // Update filter in local_metrics_filters
            const indexInLocal = this.local_metrics_filters.findIndex((filter) => filter.id === mf.id);
            if(indexInLocal >= 0) {
                this.local_metrics_filters[indexInLocal] = mf;
            } else if(!found) {
                this.local_metrics_filters.push(mf);
            }

            // Update filter in page_level_filters_list if it exists there
            const indexInPageList = this.page_level_filters_list.findIndex((filter) => filter.id === mf.id);
            if(indexInPageList >= 0) {
                this.page_level_filters_list[indexInPageList] = mf;
                this.$emit('updatePageFilters', this.page_level_filters_list);
            }

            this.local_metrics_filters.sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : -1);
            this.page_filter_options = this.getAllPageFilterOptions();
            this.closeModal('page-filter-modal');
        },
        emitPageFilterChange(event) {
            const filter_object = this.local_metrics_filters.find((filter) => filter.id === event.value);
            this.page_level_filters_list.push(filter_object);
            this.page_filter_options = this.page_filter_options.filter(option => option.value !== event.value);
            this.$emit('updatePageFilters', this.page_level_filters_list);
        },
        removePageFilterByIndex(index) {
            this.page_level_filters_list.splice(index, 1);
            this.page_filter_options = this.getAllPageFilterOptions();
            this.$emit('updatePageFilters', this.page_level_filters_list);
        },
        editFilterGroup(group_index, action) {
            if(action === 'Delete') {
                this.dimensional_filters_list.splice(group_index, 1);
                this.assignGroupOrders();
                this.showNotification({
                    text: 'Filter group was deleted!'
                });
                this.$emit('updateUserDefinedFilters', this.dimensional_filters_list);
            } else {
                this.group_index = group_index;
                this.action_for_filter_group = action;                    
            }
            if(action === 'Update') {
                this.dimensional_filter_group = {
                    id: this.dimensional_filters_list[group_index].id,
                    group_name: this.dimensional_filters_list[group_index].group_name,
                    filters: this.dimensional_filters_list[group_index].filters,
                    section_ids: this.dimensional_filters_list[group_index].section_ids != null
                        ? [...(this.dimensional_filters_list[group_index].section_ids || [])]
                        : null
                };
            }
        },
        editFilterWithinGroup(filter_index, group_index, action) {
            if(action === 'Delete') {
                this.dimensional_filters_list[group_index].filters.splice(filter_index, 1);
                this.showNotification({
                    text: 'Filter was deleted!'
                });
                this.$emit('updateUserDefinedFilters', this.dimensional_filters_list);
                this.reorderFiltersInGroup(group_index);
            } else {
                this.filter_index_within_group = filter_index;
                this.group_index = group_index;
                this.action_for_filter_in_group = action;
                if(filter_index != null) {
                    this.dimensional_filter = {...this.dimensional_filters_list[group_index].filters[filter_index]};
                    if(this.dimensional_filter.default_value === null && (this.dimensional_filter.field_type === 'date_range' || this.dimensional_filter.field_type === 'month_range')) {
                        this.dimensional_filter.default_value = {
                            start_date: null,
                            end_date: null
                        };
                    }
                }
            }
        },
        reorderFiltersInGroup(group_index) {
            this.dimensional_filters_list[group_index].filters.forEach((filter, index) => {
                filter.order = index + 1;
            });
        },
        moveFilterUpInGroup(group_index, filter_index) {
            const current_filter = {...this.dimensional_filters_list[group_index].filters[filter_index]};
            const previous_filter = {...this.dimensional_filters_list[group_index].filters[filter_index-1]};

            current_filter.order = this.dimensional_filters_list[group_index].filters[filter_index-1].order;
            previous_filter.order = this.dimensional_filters_list[group_index].filters[filter_index].order;

            this.dimensional_filters_list[group_index].filters[filter_index-1] = current_filter;
            this.dimensional_filters_list[group_index].filters[filter_index] = previous_filter;
            this.$emit('updateUserDefinedFilters', this.dimensional_filters_list);
            this.$forceUpdate();
        },
        moveFilterDownInGroup(group_index, filter_index) {
            const current_filter = {...this.dimensional_filters_list[group_index].filters[filter_index]};
            const next_filter = {...this.dimensional_filters_list[group_index].filters[filter_index+1]};

            current_filter.order = this.dimensional_filters_list[group_index].filters[filter_index+1].order;
            next_filter.order = this.dimensional_filters_list[group_index].filters[filter_index].order;

            this.dimensional_filters_list[group_index].filters[filter_index+1] = current_filter;
            this.dimensional_filters_list[group_index].filters[filter_index] = next_filter;
            this.$emit('updateUserDefinedFilters', this.dimensional_filters_list);
            this.$forceUpdate();
        },
        assignGroupOrders() {
            this.dimensional_filters_list.forEach((g, idx) => {
                g.order = idx + 1;
            });
        },
        onGroupsDragEnd() {
            this.assignGroupOrders();
            this.$emit('updateUserDefinedFilters', this.dimensional_filters_list);
        },
        onFiltersDragEnd(group_index) {
            this.reorderFiltersInGroup(group_index);
            this.$emit('updateUserDefinedFilters', this.dimensional_filters_list);
        },
        resetFilterFields() {
            this.dimensional_filter = {
                label: '',
                field_type: '',
                is_required: false,
                column: null,
                default_value: null,
                order: null
            };
        },
        resetFilterGroupFields() {
            this.dimensional_filter_group = {
                group_name: '',
                filters: [],
                section_ids: null
            };
        },
        hasGroupErrors() {
            if(this.dimensional_filter_group.group_name === null || this.dimensional_filter_group.group_name === "") {
                this.local_filter_group_errors.group_name = "A group name is required.";
            } else {
                this.local_filter_group_errors.group_name = "";
            }

            return this.local_filter_group_errors.group_name !== "";
        },
        updateFilterWithinGroup(dim_filter) {
            this.dimensional_filter = dim_filter;

            if(typeof dim_filter.column === 'object') {
                this.dimensional_filter.column = dim_filter.column.value.toString();
            }

            if(this.action_for_filter_in_group === 'Add') {
                this.dimensional_filter.order = this.dimensional_filters_list[this.group_index].filters.length + 1;
                this.dimensional_filters_list[this.group_index].filters.push({...this.dimensional_filter}); 
                this.showNotification({
                    text: 'Filter was added!'
                });
            } else {
                this.dimensional_filters_list[this.group_index].filters[this.filter_index_within_group] = {...this.dimensional_filter}; 
            }
            this.$emit('updateUserDefinedFilters', this.dimensional_filters_list);
            this.closeModal('dimension-filter-modal');
        },
        updateFilterGroup() {
            this.clearGroupErrors();
            if(this.hasGroupErrors()) {
                return;
            }
            if(this.action_for_filter_group === 'Add') {
                this.dimensional_filters_list.push({
                    group_name: this.dimensional_filter_group.group_name,
                    filters: this.dimensional_filter_group.filters || [],
                    section_ids: this.dimensional_filter_group.section_ids && this.dimensional_filter_group.section_ids.length
                        ? [...this.dimensional_filter_group.section_ids] : null
                });
                this.assignGroupOrders();
                this.showNotification({
                    text: 'A filter group was added!'
                });
            } else {
                const existingOrder = this.dimensional_filters_list[this.group_index]?.order ?? this.group_index + 1;
                this.dimensional_filters_list[this.group_index] = {
                    id: this.dimensional_filter_group.id,
                    group_name: this.dimensional_filter_group.group_name,
                    filters: this.dimensional_filter_group.filters || [],
                    section_ids: this.dimensional_filter_group.section_ids && this.dimensional_filter_group.section_ids.length
                        ? [...this.dimensional_filter_group.section_ids] : null,
                    order: existingOrder
                };
            }
            this.$emit('updateUserDefinedFilters', this.dimensional_filters_list);
            this.closeModal('filter-group-modal');
        },
        clearErrorForGroupField(field_name) {
            this.local_filter_group_errors[field_name] = '';
        },
        clearGroupErrors() {
            this.local_filter_group_errors = {
                group_name: '',
            };
        },
        closeModal(modal_ID) {
            if (modal_ID === 'dimension-filter-modal') {
                this.resetFilterFields();
            }
            if (modal_ID === 'filter-group-modal') {
                this.resetFilterGroupFields();
            }
            const myModalEl = document.getElementById(modal_ID);
            const modal = bootstrap.Modal.getInstance(myModalEl);
            modal.hide();
        }
    }
});
</script>
